import { bool, object, string, element, array } from "prop-types";
export var selectTypes = {
  id: string.isRequired,
  className: string,
  customComponents: object,
  hasError: bool,
  isAsync: bool,
  isCreatable: bool,
  isMulti: bool,
  informationCell: element,
  linkCell: element,
  placeholder: string,
  options: array,
  noInteractionBorder: bool
};